import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {MenuVisitaVinculacionOcupacion} from '../_models/menu-visita-vinculacion-ocupacion';

@Injectable({
  providedIn: 'root'
})
export class MenuVisitaVinculacionOcupacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/menuVisitaVinOcupaciones/';

  constructor(private httpClient: HttpClient, private autServicio: AutenticacionService) {
  }

  listado() {
    return this.httpClient.get(this.rutServicio).pipe(map(res => res as MenuVisitaVinculacionOcupacion[]));
  }

  listadoHabilitados() {
    return this.httpClient.get(this.rutServicio + 'enabled').pipe(map(res => res as MenuVisitaVinculacionOcupacion[]));
  }

  listadoPorMenuVisitaVinculacion( id: string) {
    return this.httpClient.get(this.rutServicio + 'menuVisitaVinculacion/' + id).pipe(map(res => res as MenuVisitaVinculacionOcupacion[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient.get(this.rutServicio + id).pipe(map(res => res as MenuVisitaVinculacionOcupacion));
  }

  crear(regCrear: MenuVisitaVinculacionOcupacion) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post(this.rutServicio, regCrear).pipe(map(res => res as MenuVisitaVinculacionOcupacion));
  }

  actualizar(regActualizar: MenuVisitaVinculacionOcupacion) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put(this.rutServicio, regActualizar).pipe(map(res => res as any));
  }

}
